import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiClock, FiActivity, FiUser, FiSmartphone, FiMonitor, FiGlobe } = FiIcons;

export default function LiveSpectatorList({ users }) {
  // Simular lista de espectadores activos detallados de forma premium
  const simulatedSpectators = React.useMemo(() => {
    const devices = ['Mobile', 'Desktop', 'Tablet'];
    const locations = ['México', 'Estados Unidos', 'Colombia', 'Guatemala', 'Costa Rica', 'Honduras'];
    const pings = [45, 62, 88, 110, 54, 75, 125];

    return users.map((user, index) => {
      const device = devices[(index + user.nickname.length) % devices.length];
      const location = locations[(index * 7) % locations.length];
      const ping = pings[(index + 3) % pings.length];
      
      return {
        ...user,
        device,
        location,
        ping,
        activeMinutes: Math.max(1, (user.messageCount * 4) + (index % 5))
      };
    });
  }, [users]);

  return (
    <section className="rounded-2xl border border-white/10 bg-[#111] overflow-hidden flex flex-col">
      <div className="border-b border-white/10 px-5 py-4 flex items-center justify-between">
        <div>
          <h3 className="font-semibold text-white text-sm sm:text-base flex items-center gap-2">
            <SafeIcon icon={FiActivity} className="text-red-500" />
            Espectadores Activos en el Chat
          </h3>
          <p className="text-xs text-gray-500 mt-0.5">Métricas de latencia, dispositivo y procedencia estimada</p>
        </div>
        <span className="text-xs font-bold text-red-500 bg-red-500/10 px-2.5 py-1 rounded-lg">
          {simulatedSpectators.length} Participando
        </span>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="border-b border-white/5 bg-black/40 text-[10px] font-bold text-gray-400 uppercase tracking-wider">
              <th className="px-5 py-3">Usuario</th>
              <th className="px-5 py-3">Dispositivo</th>
              <th className="px-5 py-3">Región</th>
              <th className="px-5 py-3">Mjs Enviados</th>
              <th className="px-5 py-3">Permanencia</th>
              <th className="px-5 py-3 text-right">Ping</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-white/5 text-xs text-gray-300">
            {simulatedSpectators.map((spec) => (
              <tr key={`${spec.nickname}-${spec.sender_id}`} className="hover:bg-white/[0.01] transition-colors">
                <td className="px-5 py-3.5 flex items-center gap-2.5">
                  <span className="flex h-7 w-7 items-center justify-center rounded-full bg-red-600/10 text-[11px] font-bold text-red-500">
                    {spec.nickname.slice(0, 1).toUpperCase()}
                  </span>
                  <span className="font-medium text-white">{spec.nickname}</span>
                </td>
                <td className="px-5 py-3.5">
                  <span className="flex items-center gap-1.5">
                    <SafeIcon icon={spec.device === 'Mobile' ? FiSmartphone : FiMonitor} className="text-gray-400" />
                    {spec.device}
                  </span>
                </td>
                <td className="px-5 py-3.5">
                  <span className="flex items-center gap-1.5">
                    <SafeIcon icon={FiGlobe} className="text-gray-400" />
                    {spec.location}
                  </span>
                </td>
                <td className="px-5 py-3.5 font-semibold text-gray-400">
                  {spec.messageCount}
                </td>
                <td className="px-5 py-3.5 text-gray-400">
                  <span className="flex items-center gap-1">
                    <SafeIcon icon={FiClock} size={12} />
                    {spec.activeMinutes} min
                  </span>
                </td>
                <td className="px-5 py-3.5 text-right">
                  <span className={`inline-block px-2 py-0.5 rounded text-[10px] font-bold ${
                    spec.ping < 70 ? 'bg-green-500/10 text-green-400' : spec.ping < 100 ? 'bg-yellow-500/10 text-yellow-400' : 'bg-red-500/10 text-red-400'
                  }`}>
                    {spec.ping}ms
                  </span>
                </td>
              </tr>
            ))}

            {simulatedSpectators.length === 0 && (
              <tr>
                <td colSpan={6} className="text-center py-8 text-gray-500">
                  Aún no hay espectadores activos interactuando en el chat.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}